import React from "react";
import { Field } from "react-final-form";
 import { TextFieldAdapter }from "@soqs/common";
const isAddress = (code) => {
  //Latin-1 without Appendix E
  const re = /^[ "0-9]{1,4}$/;
  return code && re.test(code)
    ? undefined
    : code === undefined || code?.length !== 4
      ? "Please enter a valid postal code"
      : "Please enter a valid postal code";
};

const PostalCode = ({ ...rest }) => (
  <Field
    name="pitRegPostalAddressCode"
    validate={isAddress}
    label="Postal Code"
    autoComplete="family-name"
    component={TextFieldAdapter}
    subscription={{ touched: true, value: true, error: true }}
    fullWidth
    inputProps={{ maxLength: 4, inputMode: 'numeric', pattern: '[0-9]*' }}
    required
    {...rest}

  />
);

export default PostalCode;
